import { render, staticRenderFns } from "./StockMovementsTable.vue?vue&type=template&id=99e8865a"
import script from "./StockMovementsTable.vue?vue&type=script&lang=js"
export * from "./StockMovementsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports